import { Component, OnInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'app-employeeattendance',
  templateUrl: './employeeattendance.component.html',
  styleUrls: ['./employeeattendance.component.scss']
})
export class EmployeeattendanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  addEmployeeAttendance(): void
  {
    $('#add-EmployeeAttendance').modal({ backdrop: 'static', keyboard: false });
  }

}
